
export interface OrderMessageData {
  formString: string;      // Field[0]
  orderSeqId: string;      // Field[1]
  updatedBy: string;       // Field[2]
  orderStatus: string;     // Field[3]
  orderInstruction: string;// Field[4]
  orderType: string;       // Field[5]
  lookup: string;          // Field[6] (Always "lookup")
  msgSeqNum: string;       // Field[7]
  msgType: string;         // Field[8]
  workingTrader: string;   // Field[9] (Optional, may not always be present)
}

/**
 * Parses a SignalR message string into an `OrderMessageData` object.
 * @param messageString The raw message string received from SignalR.
 * @returns A structured object containing the parsed order message data.
 */
export const parseOrderMessage = (messageString: string): OrderMessageData | null => {
  if (!messageString || typeof messageString !== "string") {
    console.error("Invalid message string:", messageString);
    return null;
  }

  const fields = messageString.split("::");

  // Ensure the message has at least 9 required fields
  if (fields.length < 9) {
    console.error("Malformed message string:", messageString);
    return null;
  }

  return {
    formString: fields[0] || "", 
    orderSeqId: fields[1] || "", 
    updatedBy: fields[2] || "", 
    orderStatus: fields[3] || "", 
    orderInstruction: fields[4] || "", 
    orderType: fields[5] || "", 
    lookup: fields[6] || "", 
    msgSeqNum: fields[7] || "", 
    msgType: fields[8] || "", 
    workingTrader: fields.length > 9 ? fields[9] : "", // Field[9] may be optional
  };
};
